import { Divider } from "components/Divider/Divider";

import styles from "./styles.module.scss";
import { Logo } from "./Logo";
import { Menu } from "./Menu";
import { BottomMenu } from "./BottomMenu";

export const LeftNavBar = (): JSX.Element => (
  <div className={styles.leftNavBar}>
    <Logo />
    <Divider />
    <Menu />
    <Divider />
    <BottomMenu />
  </div>
);
